export const getStatePromise = (chartRef) => {
  return new Promise((resolve, reject) => {
    if (chartRef && chartRef.getState) {
      chartRef.getState((err, result) => {
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      });
    } else {
      reject(new Error('getState function not available on the chartRef'));
    }
  });
};

export const generateChartKey = (data, showDecimals, currentLanguage) => {
  if (!data || data.length === 0) {
    return '';
  }

  const keyObject = { data };

  if (showDecimals !== undefined) {
    keyObject.showDecimals = showDecimals;
  }

  if (currentLanguage !== undefined) {
    keyObject.currentLanguage = currentLanguage;
  }

  return JSON.stringify(keyObject);
};
